












































































































import Vue from 'vue';
import { PersistentNotificationType } from '../lib/enums/persistentNotification';
import { stringify } from 'querystring';

const PersistentNotificationStyle = {
  [PersistentNotificationType.Info]: {
    icon: 'mdi-information',
    class: 'notification--info'
  },
  [PersistentNotificationType.Success]: {
    icon: 'mdi-check-circle',
    class: 'notification--success'
  },
  [PersistentNotificationType.Warning]: {
    icon: 'mdi-alert',
    class: 'notification--warning'
  },
  [PersistentNotificationType.Error]: {
    icon: 'mdi-alert-circle',
    class: 'notification--error'
  }
};

export default Vue.extend({
  name: 'PersistentNotificationBase',

  props: {
    notification: {
      type: Object,
      default: function () {
        return {
          type: undefined,
          title: undefined,
          text: undefined,
          link: {
            text: undefined,
            url: undefined,
            external: undefined
          },
          details: {
            text: undefined,
            link: {
              text: undefined,
              url: undefined,
              external: undefined
            }
          }
        };
      }
    },
    canHide: { type: Boolean, default: true },
    containerClass: { type: String, default: 'mb-8' },
    transition: { type: Boolean, default: true }
  },

  computed: {
    notificationIcon() {
      return PersistentNotificationStyle[
        this.notification.type as PersistentNotificationType
      ].icon;
    },

    notificationClass() {
      return PersistentNotificationStyle[
        this.notification.type as PersistentNotificationType
      ].class;
    },

    showLink(): boolean {
      return (
        this.notification.link &&
        !this.notification.link.external &&
        this.notification.link.text
      );
    },

    showExternalLink(): boolean {
      return (
        this.notification.link &&
        this.notification.link.external &&
        this.notification.link.text
      );
    },

    showNotification(): boolean {
      return !!this.notification.text;
    },

    showTitle(): boolean {
      return !!this.notification.title;
    }
  }
});
